/** Browser admission cache for synchronous allocation controls. */
import {
  verifyEditableIdRepairs,
  identityRepairNamespaceOf
} from '../shared/editable-id-repair.js';
import { canonicalStringify } from '../shared/collab-protocol.js';
import { reportError } from '../core/report-error.js';
function notifyRepairStatus(message) {
  reportError('Element identity history', new Error(message), { user: 'toast', message });
}

// Exact-input digest cache: pending/invalid evidence never authorizes allocation.
const repairAllocationChecks = new Map();
export function editableIdRepairAllocationReady(section, state, notify = notifyRepairStatus) {
  if (!section) return false;
  if (!Object.hasOwn(section, 'editableIdRepairs')) return true;
  let key;
  try {
    key = canonicalStringify([
      state?.projectId,
      identityRepairNamespaceOf(state),
      section.instanceId,
      section.editableIdRepairs
    ]);
  } catch {
    notify('Element identity history is unsupported. The element was kept unchanged.', {
      type: 'error'
    });
    return false;
  }
  let check = repairAllocationChecks.get(key);
  if (!check) {
    check = { status: 'pending' };
    if (repairAllocationChecks.size >= 128)
      repairAllocationChecks.delete(repairAllocationChecks.keys().next().value);
    repairAllocationChecks.set(key, check);
    void verifyEditableIdRepairs(structuredClone(section.editableIdRepairs), {
      instanceId: section.instanceId
    }).then(
      (result) => {
        check.status = result.ok ? 'valid' : 'invalid';
      },
      () => {
        check.status = 'invalid';
      }
    );
  }
  if (check.status === 'valid') return true;
  notify(
    check.status === 'pending'
      ? 'Checking element identity history. Try this action again in a moment.'
      : 'Element identity history cannot be verified. The element was kept unchanged.',
    { type: check.status === 'pending' ? 'info' : 'error' }
  );
  return false;
}
